import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",

    meta: {
      title: "Login Help | MyEnroll",
      tip: "",
    },
    component: () =>
      import(/* webpackCHunkName: "Returning User" */ "@/views/Home.vue"),
  },
  {
    path: "/username",
    meta: {
      title: "Username Retrieval | MyEnroll",
      tip: "Username",
    },
    component: () =>
      import(
        /* webpackCHunkName: "Returning User" */ "@/components/username.vue"
      ),
  },
  {
    path: "/password",
    meta: {
      title: "Password Retrieval | MyEnroll",
      tip: "Password",
    },
    component: () =>
      import(
        /* webpackCHunkName: "Returning User" */ "@/components/password.vue"
      ),
  },
  {
    path: "/newuser",
    meta: {
      title: "First Time User | MyEnroll",
      tip: "New User",
    },
    component: () =>
      import(/* webpackCHunkName: "New User" */ "@/views/newUser.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
